"use strict";
// @generated by protoc-gen-connect-es v1.4.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/shipping/v1/portal_service.proto (package spwn.shipping.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
exports.PortalShippingService = void 0;
const portal_service_pb_1 = require("./portal_service_pb");
const protobuf_1 = require("@bufbuild/protobuf");
/**
 * @generated from service spwn.shipping.v1.PortalShippingService
 */
exports.PortalShippingService = {
    typeName: "spwn.shipping.v1.PortalShippingService",
    methods: {
        /**
         * 住所の一括取得
         *
         * @generated from rpc spwn.shipping.v1.PortalShippingService.GetAddresses
         */
        getAddresses: {
            name: "GetAddresses",
            I: portal_service_pb_1.PortalShippingServiceGetAddressesRequest,
            O: portal_service_pb_1.PortalShippingServiceGetAddressesResponse,
            kind: protobuf_1.MethodKind.Unary,
            idempotency: protobuf_1.MethodIdempotency.NoSideEffects,
        },
        /**
         * 住所の新規作成
         *
         * @generated from rpc spwn.shipping.v1.PortalShippingService.CreateAddress
         */
        createAddress: {
            name: "CreateAddress",
            I: portal_service_pb_1.PortalShippingServiceCreateAddressRequest,
            O: portal_service_pb_1.PortalShippingServiceCreateAddressResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * 住所の更新
         *
         * @generated from rpc spwn.shipping.v1.PortalShippingService.UpdateAddress
         */
        updateAddress: {
            name: "UpdateAddress",
            I: portal_service_pb_1.PortalShippingServiceUpdateAddressRequest,
            O: portal_service_pb_1.PortalShippingServiceUpdateAddressResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * 住所の削除
         *
         * @generated from rpc spwn.shipping.v1.PortalShippingService.DeleteAddress
         */
        deleteAddress: {
            name: "DeleteAddress",
            I: portal_service_pb_1.PortalShippingServiceDeleteAddressRequest,
            O: portal_service_pb_1.PortalShippingServiceDeleteAddressResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * 既定の住所に設定
         *
         * @generated from rpc spwn.shipping.v1.PortalShippingService.SetDefaultAddress
         */
        setDefaultAddress: {
            name: "SetDefaultAddress",
            I: portal_service_pb_1.PortalShippingServiceSetDefaultAddressRequest,
            O: portal_service_pb_1.PortalShippingServiceSetDefaultAddressResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
    }
};
//# sourceMappingURL=portal_service_connect.js.map